<template>
	<app-modal @close="close" title="Number of packages?">
		<div class="flex" v-for="(row, i) in items" :key="i">
			<div
				class="flex flex-1 items-center justify-center border-1 border-success cursor-pointer w-32 h-32 m-2 hover:bg-success hover:text-white text-2xl"
				v-for="col in row"
				:key="col"
				@click="onPackageSelect(col)"
			>
				{{ col }}
			</div>
		</div>
	</app-modal>
</template>

<script>
	import AppModal from '@/components/app/AppModal';
	import OrderService from '../../services/OrderService';

	export default {
		name: 'SelectPackagesModal',
		components: {
			AppModal,
		},
		props: {
			orderId: {
				required: true,
			},
		},
		data: () => ({
			items: [
				[1, 2, 3],
				[4, 5, 6],
				[7, 8, 9],
			],
			isOpen: false,
		}),
		methods: {
			onPackageSelect(value) {
				OrderService.setPackageNo(this.orderId, value).then(() => {
					this.$emit('selected', value);
					this.close();
				});
			},
			close() {
				this.$emit('close');
			},
		},
	};
</script>
